import { DateTime } from 'luxon'

import findAgencyProvider from '@functions/findAgencyProvider'

import type { PublicationModel } from '@models/types'
import type { EntitiesState } from '@redux/entities'

type FindCurrentAgencyPriceListParams = {
  agencyId: number,
  agencyProviders: EntitiesState['agencyProviders'],
  dateNow?: object,
  providerId: number,
  providerPriceLists: EntitiesState['providerPriceLists'],
  publication?: PublicationModel,
  serviceId: number,
  startDateString?: string,
}

function findCurrentAgencyPriceList(params: FindCurrentAgencyPriceListParams) {
  const {
    agencyId,
    agencyProviders,
    dateNow = DateTime.now(),
    providerId,
    providerPriceLists,
    publication,
    serviceId,
    startDateString,
  } = params

  const priceListArray = Object.values(providerPriceLists)

  // Publication Price List
  if (publication?.id){
    const publicationPriceList = priceListArray.find(priceList => priceList.id === publication.provider_price_list_id)
    return publicationPriceList || {}
  }

  // Use price list for agency if set
  const agencyProvider = findAgencyProvider({
    agencyProviders, agencyId, serviceId, providerId,
  })

  // @ts-expect-error TS2339
  if (agencyProvider.provider_price_list_id){
    // Current Price List
    // @ts-expect-error TS2339
    const currentPriceList = providerPriceLists[agencyProvider.provider_price_list_id] || {}

    const expiryDateString = currentPriceList.dates?.expiry?.date || ''
    const expiryDate = expiryDateString
      ? DateTime.fromFormat(expiryDateString, 'dd/MM/yyyy')
      : null

    const startDate = startDateString
      ? DateTime.fromFormat(startDateString, 'dd/MM/yyyy')
      : dateNow

    // Check if Current Price List is Expired
    if (
      expiryDate
      && startDate
      && expiryDate <= startDate
      && currentPriceList.next_price_list_id
      && providerPriceLists[currentPriceList.next_price_list_id]
    ){
      return providerPriceLists[currentPriceList.next_price_list_id]
    }

    return currentPriceList
  }

  // Use the default
  const defaultPriceList = priceListArray.find(
    priceList => priceList.default && priceList.provider_id === providerId && priceList.service_id === serviceId,
  )

  return defaultPriceList || {}
}

export default findCurrentAgencyPriceList
